/* beautiful-react-hooks version: 0.35.0 */
import useGeolocationState from './useGeolocationState.js';
import useGeolocationEvents from './useGeolocationEvents.js';
import geolocationStandardOptions from './utils/geolocationStandardOptions.js';

var useGeolocation = function useGeolocation() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : geolocationStandardOptions;
  var state = useGeolocationState(options);
  var events = useGeolocationEvents(options);
  return [state, events];
};

export default useGeolocation;
